import React, { useState } from 'react';
import { Modal, Button, Form, Alert, Badge } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';

const EditBimbinganModal = ({ show, onHide, bimbingan, onSave, loading, error, isReview = false }) => {
  const { userRole } = useAuth();
  const [judul, setJudul] = useState(bimbingan?.judul || '');
  const [fileURL, setFileURL] = useState(bimbingan?.fileURL || '');
  const [tanggal, setTanggal] = useState(bimbingan?.tanggal ? bimbingan.tanggal.slice(0,10) : '');
  const [revisiPoin, setRevisiPoin] = useState(Array.isArray(bimbingan?.revisiPoin) ? bimbingan.revisiPoin : []);
  const [isReviewed, setIsReviewed] = useState(bimbingan?.status === 'reviewed');

  // Debug log
  console.log('EditBimbinganModal rendered', { show, bimbingan, isReview });

  // Jika ada perubahan bimbingan yang diedit
  React.useEffect(() => {
    setJudul(bimbingan?.judul || '');
    setFileURL(bimbingan?.fileURL || '');
    setTanggal(bimbingan?.tanggal ? bimbingan.tanggal.slice(0,10) : '');
    setRevisiPoin(Array.isArray(bimbingan?.revisiPoin) ? bimbingan.revisiPoin : []);
    setIsReviewed(bimbingan?.status === 'reviewed');
  }, [bimbingan]);

  const handlePoinChange = (idx, value) => {
    const updated = [...revisiPoin];
    updated[idx] = value;
    setRevisiPoin(updated);
  };
  const handleAddPoin = () => setRevisiPoin([...revisiPoin, '']);
  const handleRemovePoin = idx => setRevisiPoin(revisiPoin.filter((_, i) => i !== idx));

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const updatedBimbingan = { 
      ...bimbingan, 
      judul, 
      fileURL, 
      tanggal, 
      revisiPoin 
    };
    
    // If marked as reviewed, update the status and timestamp
    if (isReviewed) {
      updatedBimbingan.status = 'reviewed';
      updatedBimbingan.tanggalReview = new Date().toISOString();
    }
    
    onSave(updatedBimbingan);
  };

  return (
    <Modal show={!!show} onHide={onHide} backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {bimbingan?.status === 'pending' ? 'Edit & Review Bimbingan' : 'Edit Sesi Bimbingan'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        
        {bimbingan && (
          <div className="mb-3">
            <h6>Informasi Bimbingan:</h6>
            {bimbingan.tugasAkhir?.mahasiswa && (
              <p><strong>Mahasiswa:</strong> {bimbingan.tugasAkhir.mahasiswa.nama || '-'}</p>
            )}
            <p><strong>Sesi:</strong> {bimbingan.sesi}</p>
            <p>
              <strong>Status:</strong>{' '}
              <Badge bg={bimbingan.status === 'reviewed' ? 'success' : 'warning'}>
                {bimbingan.status === 'reviewed' ? 'Sudah Direview' : 'Menunggu Review'}
              </Badge>
            </p>
            
            <Button 
              variant="primary" 
              href={bimbingan.fileURL}
              target="_blank"
              rel="noopener noreferrer"
              className="mb-3"
              size="sm"
            >
              Lihat Dokumen Mahasiswa
            </Button>
          </div>
        )}
        
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Judul Sesi</Form.Label>
            <Form.Control
              type="text"
              value={judul}
              onChange={e => setJudul(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Link Google Drive</Form.Label>
            <Form.Control
              type="text"
              value={fileURL}
              onChange={e => setFileURL(e.target.value)}
              required
            />
            <Form.Text className="text-muted">
              {bimbingan?.status === 'pending' && userRole === 'dosen' ? 
                "Link dokumen mahasiswa. Dosen dapat mengunggah revisi menggunakan format PX_revY_nama dengan X=nomor pembimbing, Y=nomor revisi (contoh: P1_rev2_Ayleen)." :
                "Link dokumen bimbingan. Gunakan format prop_NIM_Nama untuk dokumen awal. Saat menambahkan sesi baru, link ini akan otomatis terisi dengan link terakhir."
              }
            </Form.Text>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Tanggal Bimbingan</Form.Label>
            <Form.Control
              type="date"
              value={tanggal}
              onChange={e => setTanggal(e.target.value)}
              required
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Poin Revisi</Form.Label>
            <Form.Text className="text-muted d-block mb-2">
              Masukkan poin-poin revisi atau catatan untuk mahasiswa
            </Form.Text>
            {revisiPoin.length === 0 && <div className="mb-2 text-muted">Belum ada poin revisi.</div>}
            {revisiPoin.map((poin, idx) => (
              <div key={idx} className="d-flex mb-2 gap-2">
                <Form.Control
                  type="text"
                  value={poin}
                  onChange={e => handlePoinChange(idx, e.target.value)}
                  placeholder={`Poin revisi #${idx+1}`}
                />
                <Button variant="danger" size="sm" onClick={() => handleRemovePoin(idx)} disabled={loading}>&times;</Button>
              </div>
            ))}
            <Button variant="secondary" size="sm" onClick={handleAddPoin} disabled={loading}>
              + Tambah Poin Revisi
            </Button>
          </Form.Group>
          
          {bimbingan?.status === 'pending' && (
            <Form.Group className="mb-3">
              <Form.Check 
                type="checkbox"
                id="review-checkbox"
                label="Tandai sebagai sudah direview"
                checked={isReviewed}
                onChange={e => setIsReviewed(e.target.checked)}
              />
              <Form.Text className="text-muted">
                Centang ini untuk menandai sesi bimbingan sebagai sudah direview dan dapat dilihat oleh mahasiswa.
              </Form.Text>
            </Form.Group>
          )}
          
          <Button variant="primary" type="submit" disabled={loading} className="mt-3">
            {loading ? 'Menyimpan...' : 'Simpan Perubahan'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditBimbinganModal;
